import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as configs } from 'src/environments/environment';
import { NzModalService } from 'ng-zorro-antd';
import { CommonService } from '../../common.service';
var PayreceiptComponent = /** @class */ (function () {
    function PayreceiptComponent(activeRoute, httpClient, confirmServ, router, CSF) {
        this.activeRoute = activeRoute;
        this.httpClient = httpClient;
        this.confirmServ = confirmServ;
        this.router = router;
        this.CSF = CSF;
        this.host = configs['ApiHost'];
        this.diplayReceipt = false;
        this.receiptData = {};
        this.jsonData = {};
    }
    PayreceiptComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userRole = JSON.parse(localStorage.getItem('user')).role.toString();
        this.activeRoute.params.subscribe(function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var resp, d, paydate, paydate;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.receiptId = e.id;
                        return [4 /*yield*/, this.httpClient.post(this.host + '/payment/receipt/' + this.receiptId, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).toPromise()
                            // console.log(resp)
                        ];
                    case 1:
                        resp = _a.sent();
                        // console.log(resp)
                        if (resp['data'].length > 0) {
                            d = resp['data'][0];
                            if (d.WC_PaymentThrough.toLowerCase() != 'online' || d.WC_PaymentThrough.toLowerCase() != 'csc') {
                                paydate = d.WC_PayDateTime.substr(0, 10).split('-');
                                // let a=paydate[2];
                                // paydate[2]=paydate[0];
                                // paydate[0]=a
                            }
                            else {
                                paydate = d.WC_PayDateTime.split(',')[0].split('-');
                            }
                            this.receiptData = {
                                name: d.WRG_Name,
                                fname: d.WRG_FatherName,
                                dob: d.WRG_DOB,
                                fromD: d.WC_StartDate.substr(0, 10),
                                toD: d.WC_EndDate.substr(0, 10),
                                Address: d.WRG_Address,
                                pmthd: d.WC_PaymentThrough,
                                fileNo: d.WC_WorkerRegno,
                                circle: d.circle,
                                subdiv: d.subdiv,
                                transNo: d.WC_TransNo,
                                BnkRef: d.WC_BankRefNo,
                                feePaid: d.WC_AmountPay,
                                years: parseInt(d.WC_Month) / 12,
                                paydate: this.CSF.dateToYYMMDD(paydate[2] + '-' + paydate[1] + '-' + paydate[0])
                            };
                            this.jsonData = JSON.stringify({
                                N: d.WRG_Name,
                                F_HN: d.WRG_FatherName,
                                DB: d.WRG_DOB,
                                FD: d.WC_StartDate.substr(0, 10),
                                TD: d.WC_EndDate.substr(0, 10),
                                FN: d.WC_WorkerRegno,
                                TR: d.WC_TransNo,
                                BR: d.WC_BankRefNo,
                                F: d.WC_AmountPay
                            });
                        }
                        else {
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    PayreceiptComponent.prototype.goBackESewa = function () {
        window.location.href = this.host + "/back/to/esewa";
    };
    return PayreceiptComponent;
}());
export { PayreceiptComponent };
